import { useEffect, useState } from "react";
import EventsControlsFolder from "../../../folder_modals/EventsControlsFolder";
import FolderChat from "../../../messages/FolderChat";
import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  listenDocDataByRef,
} from "../../../models/DataFunctions";
import { getOrRefreshFirebaseToken } from "../../../config/getFirebaseToken";
import getTemporaryUrl from "../../../api/getTemporaryUrl";
import { isFolderAdmin } from "../FolderHelpers";
import CustomAccordion from "../../../layout/CustomAccordion";

export const FolderMessagesSection = ({
  folderData,
  messages,
  orgData,
  userData,
  masterData,
  dropped_files,
  dropped_exists,
  resetDroppedFiles,
  sendToDrop,
  navigateWorkspace,
  workspaceData,
  setMessages,
  id,
  prefix,
}) => {
  useEffect(() => {
    if (folderData) {
      handleFetchMessages(folderData, null);
    }
  }, [folderData.ref]);

  const [unsubscribe, setUnsubscribe] = useState(null);
  const [fodlerconvData, setFolderConvData] = useState(null);
  const [has_unread, setHasUnread] = useState(false);

  useEffect(() => {
    if (!fodlerconvData) return;
    const unsubscribe = listenDocDataByRef(fodlerconvData.ref, (data) => {
      handleFetchMessages();
    });
    setUnsubscribe(unsubscribe);
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [fodlerconvData?.ref]);

  const handleFetchMessages = async () => {
    try {
      if (!folderData) return;
      const token = await getOrRefreshFirebaseToken();

      let folderconv = await getDocDataByRef(folderData.folderconv);
      setFolderConvData(folderconv);
      await getTemporaryUrl(token, "messages", "none", id, prefix);

      // Fetch messages based on folderconv data
      const messages = await getArrayDocDataByRef(folderconv.messages);

      // Set the state with the retrieved data
      setMessages(messages);
      if (
        folderData.notified_orgs_id &&
        folderData.notified_orgs_id.includes(orgData.id)
      ) {
        setHasUnread(true);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  return (
    <>
      <div className="flex flex-col w-c350 min-w-c350  ">
        <CustomAccordion
          startOpen={has_unread}
          title="Messages"
          userData={userData}
        >
          <div className=" w-full flex flex-col min-h-fit ">
            <FolderChat
              folder={folderData}
              messages={messages}
              orgData={orgData}
              onUpdate={handleFetchMessages}
              dragging={dropped_exists}
              uploadedlist={dropped_files}
              resetDroppedFiles={resetDroppedFiles}
              sendDrop={sendToDrop}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              userData={userData}
            ></FolderChat>
          </div>
        </CustomAccordion>
        <div className="h-fit flex flex-col mt-1">
          <div className="flex flex-col w-c350 min-w-c350 ">
            {isFolderAdmin(orgData, folderData) && (
              <CustomAccordion
                title="Contrôles et évènements"
                userData={userData}
              >
                <EventsControlsFolder
                  userData={userData}
                  folderData={folderData}
                  masterData={masterData}
                  navigateWorkspace={navigateWorkspace}
                ></EventsControlsFolder>
              </CustomAccordion>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
